// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"4c8c982c","224":"99316f1a","420":"db1432f7","454":"d68ef0ff","486":"1fcf7eb0","717":"16cbfc1c","787":"9e2a8ab0","838":"824b0d35","862":"e3aa726e","967":"52386891"}[chunkId] + ".chunk.js";
};